import { Button, IconButton, Menu, MenuItem, Stack, Typography, useTheme } from '@mui/material';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import { useAuth0 } from '@auth0/auth0-react';
import { useState, MouseEvent } from 'react';

interface UserSwitcherProps {
  toggleSidebar: () => void;
  isSidebarOpen: boolean;
}

export const UserSwitcher = ({ toggleSidebar, isSidebarOpen }: UserSwitcherProps) => {
  const theme = useTheme();
  const { logout, user, isLoading } = useAuth0();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
    handleClose();
  };

  if (isLoading) {
    return <Typography>Loading&hellip;</Typography>;
  }

  // we should not hit this as all routes with UserSwitcher should be wrapped in PrivateRoute
  if (!user) {
    return <Typography color="error">User data not found</Typography>;
  }

  return (
    <>
      <Stack direction="row" alignItems="center" gap={2} flexWrap="wrap">
        <AccountBoxOutlinedIcon sx={{ width: theme.spacing(8), height: theme.spacing(8) }} />
        {isSidebarOpen && (
          <>
            <Typography flex={1}>{user.name}</Typography>
            <IconButton onClick={handleClick} color="secondary" sx={{ ...theme.mixins.roundedIconButton, mr: 2 }}>
              <ExpandMoreOutlinedIcon />
            </IconButton>
          </>
        )}
        {/* TODO: change the toggle button once it has been decided what it'll look like */}
        <Button onClick={toggleSidebar}>Toggle</Button>
      </Stack>
      <Menu anchorEl={anchorEl} open={open} onClose={() => handleClose()}>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
};
